import _classCallCheck from "/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

/* eslint-disable max-classes-per-file */
var BreakpointNotFoundError =
/*#__PURE__*/
function (_Error) {
  _inherits(BreakpointNotFoundError, _Error);

  function BreakpointNotFoundError(breakpoint) {
    _classCallCheck(this, BreakpointNotFoundError);

    return _possibleConstructorReturn(this, _getPrototypeOf(BreakpointNotFoundError).call(this, "Breakpoint '" + breakpoint + "' not found"));
  }

  return BreakpointNotFoundError;
}(_wrapNativeSuper(Error));

var NextBreakpointNotFoundError =
/*#__PURE__*/
function (_Error2) {
  _inherits(NextBreakpointNotFoundError, _Error2);

  function NextBreakpointNotFoundError(breakpoint) {
    _classCallCheck(this, NextBreakpointNotFoundError);

    return _possibleConstructorReturn(this, _getPrototypeOf(NextBreakpointNotFoundError).call(this, "Next breakpoint for '" + breakpoint + "' not found"));
  }

  return NextBreakpointNotFoundError;
}(_wrapNativeSuper(Error));

export { BreakpointNotFoundError, NextBreakpointNotFoundError };